// src/data/questions.js

export const questions = {
  HappyHour: [
    "What's your most awkward moment?",
    "What's the last text message you sent?",
    "What’s the worst advice you’ve ever received?",
    "What's the weirdest compliment you've ever gotten?",
    "What design should I get for permanent art deposited into my skin with needles?",
    "What thing are you desperate for me to see, and what snack should I bring?",
    "What color are my eyes?",
    "Have you bragged about me to other people, and what did you say?",
    "How have I impacted your life in a way I may not know about?",
    "What's the biggest fear you've overcome?",
    "If you could instantly gain any skill, what would it be?",
    "What would you entrust me with above anyone else?",
    "What dish do you slay every time you make it?",
    "When was the last time you laughed so hard you cried?",
    "What's the strangest nickname you've ever been given?",
    "What smell takes you back to childhood?",
    "What is something you know you'll accomplish, no matter how many people tell you you can't?",
    "What would be your cheesy, 20-second, game-show-contestant anecdote?",
    "What discontinued item do you wish would come back?",
    "What is your happiest memory from when you were a single-digit-aged child?",
    "What bad habit have you kicked?",
    "What did you do on your very first date ever?",
    "What positive impact do you think you have on other people?",
    "What are you rooting for me to achieve?",
    "Name a dream of yours that you've made come true?",
    "What's the hold music for your brain?",
    "If I couldn't reach an itch, would you do me a solid and scratch it?",
    "What's the kindest thing the person to your left has ever done for you?",
    "What's your favorite thing to waste money on?",
    "What's something that completely changed you when you encountered it for the first time?",
    "What's something you're proud of that not many people know about?",
    "Do you tell me 'that haircut looks great'-level white lies to be nice?",
    "What's the best compliment you've ever been given?",
    "On what totally meaningless topic could you write a whole dissertation?",
    "What movie or TV character do I most remind you of?",
    "What do our matching jackets look like, and what do they say on the back?",
    "What album have you spun the most times?",
    "What snack do you turn to in times of emotional turmoil?",
    "Describe a time you accidentally mortified your parents as a child.",
    "What is the most comforting sound in the world?",
    "Tell me your favorite joke.",
    "What's the best zinger you've ever come up with on the fly?",
    "Have you ever been in love, and how do you know?",
    "Does your hometown have a notoriously spooky landmark?",
    "Describe your first real kiss.",
    "What's the most considerate present you've ever received, and how did you react when you received it?",
    "What's something you think I'm self-conscious about, but that you think I should stop stressing over?",
    "What's the most fun you've ever had with strangers?",
    "What movie title describes your last relationship?",
    "What's something you think people should appreciate more about you?",
    "Do you think you are happier or sadder than the average person, and why?",
    "What movie or TV quote hits a little too close to home?",
    "If you could plan the perfect night with all of your friends, what would it entail?",
    "If I were a perfume or cologne, what would my top, heart, and base notes be?",
    "What song is guaranteed to hit you right in the feels, no matter the time or place?",
    "Aside from 'moist', what word can't you stand the sound of?",
    "If it offered you a stipend to update me on my life every Sunday for a year, would you do it?",
    "If there were no barriers to entry, what job do you think you'd be amazing at?",
    "If you could live anyone else's life, whose would it be?",
    "Do you have any scars you want to show us, and what's the story behind how you got it?",
    "Tell us about a style choice from your past that you're glad stayed in the past.",
    "Have you ever been wildly overpaid, and who paid you and why was it so valuable to them?",
    "What's the weirdest way you've ever earned money, and how much did you get?",
    "What song reminds you of me whenever you hear it?",
    "What makes you so much fun?",
    "What's something you do that most people probably don't?",
    "What board game are you positive you could destroy us all at?",
    "What's the most common thing people praise or compliment you for?",
    "If you were a Care Bear, what would be on your belly?",
    "What does your ultimate Sunday look like?",
    "What's the most kickass you've ever felt?",
    "If dogs and their owners are supposed to have matching personalities, what type of dog should I get?",
    "What's something that's worth doing a second time, like a cover of a song or reheated leftovers?",
    "What's something you've done to try to be cool, and did you impress anyone?",
    "What song are you most ashamed to admit to me that you love?",
    "Tell me a fact you think I don't know, and if I know it, you have to drink.",
    "Would you trust me to pierce your ear, 80's-sleepover style?",
    "If someone did me wrong, would you comfort me, distract me, or get revenge for me?",
    "What's the title of your autobiography, and extra imaginary points if it includes a colon and a subtitle?",
    "If we were flying somewhere together, who would volunteer to sit in the middle seat?",
    "Describe an act of petty protest you waged at work or school.",
    "What's a situation that is always improved by my presence?",
    "What hidden talent do you suspect I have, and what makes you think so?",
    "What's the worst date you've ever been on, and tell us all the juicy deets?",
    "What motto would you put on your family crest?",
    "What smell is the most nostalgic for you?",
    "What's something everyone said you would regret, but you didn't?",
    "What's the greatest fashion risk you've taken as an adult, and how cool did you feel?",
    "What type of person have you always wanted to date, but never had the chance?",
    "How would Childhood You describe you now, and would that kid like you?",
    "Out of all of us, whose eyes would you like to see the world through for a day?",
    "Tell us about the one that got away.",
    "Pay me a sincere and specific compliment.",
    "What did you think you would hate, but ended up loving?",
    "What's the bravest thing you've ever done?",
    "What's the first app you open when you wake up in the morning?",
    "Fill in the blank: I don't care if it's for kids, I will still love it until I die, and defend your position.",
    "How many seconds is the ideal hug, and should we all test your hypothesis?",
    "What are you anxious about, and can we reassure you?"
  ],
  OnTheRocks: [
    "Will we be friends in ten years?",
    "What is something you like about me that other people just don't appreciate?",
    "If you had to eat one delectable part of my delicious body, what part would you choose? THIS ROUND'S ON ME",
    "What personal demon are you in denial about?",
    "Tell us about a time you set something in motion and left the fallout for others to deal with.",
    "When was the last time you lost your cool? What happened? How do you feel about it now?",
    "What's something you think that I got away with, but that you never could?",
    "What's something you've always done—and only realized as an adult that it was weird?",
    "Describe me in three words from a language that you do not speak well.",
    "What's a grand gesture you tried to save or repair a relationship?",
    "What's something you understand about your parents now that you're grown up? Do they understand you now?",
    "Tell us what you wish you'd said during your last breakup, but didn't. THIS ROUND'S ON ME",
    "Have you ever been fired? If so, what for? If not, why not?",
    "Describe a time when you really thought you might die.",
    "What's something about your personal hygiene that you could be more rigorous about?",
    "Our minds have traded bodies. What's the first thing you're going to do in my body?",
    "Have you ever ghosted someone you were close with?",
    "Tell us what you do to annoy your partner on purpose.",
    "What's a place where you feel at home where I would absolutely not fit in?",
    "Assuming you were single, what would it take for you to get back together with your last ex?",
    "What's something that you do that you wonder if other people do too, but don't know for certain?",
    "Tell us about a time you got more wasted than was advisable.",
    "Do your best (or worst) impersonation of me. I promise to clap appreciatively.",
    "Write me a new dating app bio in three sentences or less.",
    "What is your worst coping mechanism? Defense mechanism?",
    "Have you broken any bones? What happened? Did you hear the crack?",
    "I get a news alert that instantly makes me extremely happy—but no one else here cares. What's the news? THIS ROUND'S ON ME",
    "What's my greatest physical asset? Don't be shy.",
    "Tell us about a time you observed me lying to someone else. Was it the right thing to do?",
    "Have you ever dated a friend's ex? Ever wanted to?",
    "If I could help you with one unpleasant task, what would it be? What makes me the right choice for the job?",
    "We're starting a business. What venture would we be most successful at as a pair?",
    "Describe your worst bathroom-related disaster.",
    "Tell me about a disagreement we had—and how we resolved it. Has it made us stronger?",
    "Describe the last time you were out of control.",
    "What have you borrowed from me and still not returned? Can I have it back right now?",
    "Have you ever shared a piece of information that you realized too late was probably supposed to be a secret?",
    "I don't know why you put up with me! Why do you keep me around?",
    "Name a time you could have helped someone, but didn't bother.",
    "Tell us about a time you were shot down romantically.",
    "What have I ruined for you?",
    "What's the worst thing you've ever had to do at work or school? How'd you handle it?",
    "Of all the things we do together, what is the best thing we do together?",
    "What did you get in major trouble for doing as a kid, and did you ever learn your lesson?",
    "Have you ever sat back and watched me confidently do something incorrectly?",
    "What's something you did for free as a favor, that in retrospect, you really wish you'd charged for?",
    "Would you ever see a band that you hated in concert, just to make me happy? Have you?",
    "Tell us about a time you shot someone down romantically.",
    "Do you over-pity laugh at my jokes, even if you don't think they're funny?",
    "What are your vices? Have they gotten better or worse over time?",
    "If I were in a relationship with someone you hated, would you tell me?",
    "If you could have any body part of mine (for aesthetic, not medical, reasons), what would it be?",
    "What interest have you given up due to a community you didn't want to be a part of?",
    "Do you think I'm capable of doing something you could never forgive me for?",
    "Science has advanced, and now you and I are raising our five-year-old together. How are we doing? What is the kid like?",
    "Someone who's never met me asks you what I'm like. How do you answer?",
    "Has your ego ever gotten in the way of apologizing or patching up a fight? Did you ever resolve it?",
    "What's a piece of pop culture that makes you suspicious of anyone who is a fan?",
    "If we were to meet for the first time today, would we become friends?",
    "What was your most embarrassing moment that transpired in public? Let's all relive it!",
    "If I killed somebody, under what circumstances would you help me cover it up?",
    "Have you ever stolen anything? What, and why? Do you still have it?",
    "What is your favorite memory of our relationship?",
    "What would be the worst thing about having me as a travel companion?",
    "Do you think you are more or less attractive than the average person? Why?",
    "Have you ever done something with the goal of impressing specifically me?",
    "What's a comment someone made about you that burned itself into your mind and forever altered your behavior?",
    "What's your most expensive mistake?",
    "What's the biggest lie you've ever come up with to cancel plans?",
    "What's something you avoid because you're afraid you'll enjoy it too much?",
    "We're road tripping through the middle of nowhere. Do you have me drive or navigate?",
    "How are we wrong for each other romantically?",
    "What's an offense you've committed that could get you fired from work?",
    "Describe the first time we met. What was your honest first impression of me?",
    "How would your life be worse if we had never met?",
    "Describe my perfect life partner. Have I been on the right track to find this person?",
    "If I listed you as my job reference, what would you say about me? Would it all be true?",
    "How long did it take you to get over your last ex? What did you do to get over it? Are you actually over it?",
    "Which of us do you think has committed more crimes?",
    "What have you learned from me?",
    "Have you ever just let me win?",
    "What's a habit, compulsion, or relationship you wish you could quit?",
    "When was the last time you cried? What happened?",
    "Was your childhood happier than the average person's?",
    "What's something I talked you out of doing, and it was the right call?",
    "What do you wish you were as good at as me?",
    "What's something you're self-conscious about? Are you working on it?",
    "Who's the smartest person here? Make your case.",
    "You and I are dating. What's going to break us up?",
    "Have you been blocked by any celebrities on social media? Tell us the story!",
    "Every friendship involves give-and-take. Which one am I?",
    "What's the longest period of time you could share a hotel room with me before never wanting to see me again?",
    "What would you never hire me to do?",
    "If I didn't have my current job, what do you see me doing?",
    "Have you ever seen me charm my way out of trouble?",
    "Describe a time when you really disappointed someone. Did you ever earn back their trust?",
    "If someone important to you said they'd stop seeing you unless you stopped seeing me, would you?",
    "Tell us about a secret you had to keep from your loved ones.",
    "If I were a chain restaurant, which one would I be and why?"
  ],

  LastCall: [
    "What problem do you think you're successfully hiding from everyone, but is actually completely obvious?",
    "Have you ever pretended to be someone else online? Who is this alter ego, and were you ever found out?",
    "What do you think you're great at, but you're actually thoroughly average at?",
    "What are you stubborn about that's making your life miserable?",
    "Am I your type? What would I have to do to become more your type? I'm not hitting on you, we're just talking.",
    "What’s the most terrible thing you’ve ever done for money?",
    "Your Google history has been made public. Which search is the hardest to explain?",
    "What is something you're struggling with that we don't know about?",
    "Have you ever intentionally scammed someone or misled them for personal gain?",
    "Have you ever talked about me behind my back? If yes, what did you say?",
    "What animal am I most like? Describe how this species and I are similar.",
    "If someone were interested in dating me, what story would you tell them to see if they can handle me?",
    "Tell us about a loophole you exploited until you got caught.",
    "How comfortable are we with one another? Give us an example.",
    "If we were dying of thirst, the last bottle of water between all of us here, who would get it?",
    "How many kids is too many kids? How many will you have?",
    "What ethical boundaries are you happy to cross?",
    "What’s the meanest thing you’ve seen me do?",
    "Name a time you wished you could have helped me. What would you have done?",
    "Are there certain situations with me you avoid on purpose?",
    "What’s the most self-serving thing you’ve ever done?",
    "Tell us about a time you deliberately did something to provoke your partner.",
    "When was the last time you lied to me? What was the lie?",
    "Have you ever had a pregnancy scare?",
    "What advice do I need but don’t want to hear?",
    "Would Adult Me be attractive to Teenage You?",
    "Name a friend of mine you aren’t the biggest fan of. Is there anything you think I should reconsider about them?",
    "When do I demand the most attention?",
    "Have you ever had to apologize to someone for my behavior? Did the person accept the apology?",
    "What’s something that’s definitely not my problem, but somehow always becomes my problem?",
    "What’s your greatest moment of telling someone off? Can you reenact it for us?",
    "Describe a time you lost a little bit of respect for me.",
    "Have I ever done anything you think should have gotten me shitcanned?",
    "What’s a fact I can never seem to remember about you?",
    "What’s the angriest you’ve ever been at me? What resolved it?",
    "What would you never, ever want my help with?",
    "What’s a bad habit that you picked up from me?",
    "What’s something you’re currently doing that you’ll stop if and only if you get caught?",
    "If we met up again after not seeing each other for five years, what’s the first thing we’d do together?",
    "How’s my drug and alcohol use? Do you think I could stand to do more, or less?",
    "Have you ever been genuinely scared of me?",
    "What’s the shallowest reason you’ve ever swiped left on a dating profile?",
    "What’s the most embarrassing thing you’ve had to ask Google?",
    "What will you never understand about me?",
    "What’s something you learned from watching someone else fail spectacularly?",
    "Have you ever stabbed someone in the back or actively plotted against them?",
    "What’s something you know would make you a better person, but you just don’t want to do it?",
    "What’s the most annoying thing I do without realizing it?",
    "What’s the weirdest thing about me?",
    "Do you think I care more or less about my reputation than most people? What’s your evidence?",
    "If you found out I’d been embezzling from work, would you rat me out?",
    "What’s the closest we’ve ever come to parting ways forever? Did we fix the problem, or are we in denial?",
    "Rate my current outfit on a scale of 1-10. Is this better or worse than I usually look?",
    "What percentage of the time do you think I’m completely full of shit?",
    "What’s the most unhygienic thing you’ve ever seen me do?",
    "How have you dishonored your parents?",
    "Do any of your friends not like me?",
    "Have you ever become attracted to someone solely because you thought they might be into you?",
    "Have you ever caught me in a lie? Did you confront me about it? Why or why not?",
    "Where are we, and what are we doing, in ten years? Are we still on our bullshit?",
    "What’s something I do that you hate?",
    "What’s the most unreasonable thing you’ve ever completely lost your cool over?",
    "What’s a problem you let go on for too long before you addressed it?",
    "Do you consider me a name-dropper? What’s the last name you heard me drop?",
    "What do you think I need to just let go of?",
    "Have you ever broken off plans with me to be with someone else?",
    "If I died tomorrow, what regrets would you have about our relationship?",
    "What’s the most egregious lie you’ve ever told me?",
    "Do you think I’ll ever change myself?",
    "What’s something I talk about so much that you never need to hear about it again?",
    "What’s something about which we have such different taste that if I like it, you already know you’ll hate it?",
    "What am I too picky about? Do you think I have a more dominant or more submissive personality? Do you have any examples?",
    "Do you think I have overachieved or underachieved?",
    "What thing do I love that you absolutely hate?",
    "Do I tend to be too easy on people, or too harsh?",
    "What’s the most serious crime you’ve ever committed?",
    "Who here is most likely to believe in supernatural, occult, or mystical stuff?",
    "Do you think I ever stir up drama because I enjoy it? Name an example.",
    "What’s the disclaimer you give people before they meet me?",
    "If you suspected I had been replaced by a bodysnatcher, what would you do?",
    "What album title describes our relationship?",
    "Am I more of an unstoppable force or an immovable object?",
    "What’s something about me that might show through to others?",
    "What’s something about me that people don’t get, but you do?",
    "What’s something you think people should never joke about?",
    "Of the people here, whose job do you think pays the most? Do you think that person should Venmo each of us twenty bucks?",
    "Who’s the most annoying person here?",
    "What’s the most fundamental difference between us? Should we try to resolve it, or celebrate it?",
    "Have you ever done something you’re not proud of for money (outside of an official job)?",
    "What’s the closest we’ve ever come to breaking up?",
    "If we ever fell out, what would be the reason?",
    "Have you ever done something so stupid you regret it years later?",
    "What’s the most embarrassing thing that’s ever happened to you?",
    "What’s the most selfish thing you’ve ever done for your own benefit?"
  ],

 ExtraDirty: [
  "What’s the most surprising discovery you've made about your own body?",
  "Have you ever had to contact past partners for public health reasons?",
  "If you could send a message back in time to your teenage self about sex, what advice will you impart?",
  "Describe your nipples as vividly as possible.",
  "What’s the sex skill you're most proud of?",
  "What’s a sexual thing you gave a good try, but just couldn’t get into?",
  "Do you have any porn actually downloaded and saved on your phone? What emergency are you preparing for?",
  "Have you ever had sex with someone who was already in a committed relationship?",
  "Have you ever walked in on your parents doing that thing that grownups do when they love each other very much?",
  "When was the last time you gave us a passionate example of your dirty talk?",
  "Do you see yourself committing to one sexual partner for the rest of your life?",
  "What’s the weirdest porn you’ve ever clicked on? Did you watch the whole thing, or just enough?",
  "If you and I were in a porn together, what would its clickbait title be? Would it live up to that promise?",
  "Tell us about an awkward or unexpected sex dream you’ve had. Was anyone here involved?",
  "Tell us about the first time you experienced inadvertent nudity. When did it happen to you?",
  "Describe one of the finest and most memorable orgasms you ever had. What were the conditions?",
  "Who’s had more sex, you or your parents?",
  "Have you ever slid into someone’s DMs? Any techniques you want to share?",
  "Do you find me physically attractive? What if I bat my eyelashes like this?",
  "Have you ever gotten down in public?",
  "How much money would a voyeuristic billionaire have to pay us for us to have sex for their entertainment?",
  "Who do you think has had more sexual partners, you or me?",
  "Where’s the strangest place you’ve had sex?",
  "Have you ever feared for your life or safety while drinking or on drugs? Take us to the scene.",
  "Describe the perfect foreplay: what activities, and for how long?",
  "Are you more sexperimental, or less sexperimental, than the average person?",
  "What would it take for us to have an open relationship?",
  "How confident are you in your sexual orientation? Have you ever experimented outside of it, or considered it?",
  "Have you ever had a one-night stand? Did you know their last name, and do you remember it now?",
  "What’s your most-complimented anatomical feature (as described by your lovers)?",
  "If you can abstain from sex and masturbation for one full year, you’ll win $27,000 and a nice used car. Will you make it?",
  "How did your parents talk to you about sex? Did you learn more about it from them or elsewhere?",
  "Food and sex. Tell us about an experience involving both.",
  "List all the illicit drugs you’ve tried. Which others would you like to try?",
  "We’re all making a porn together! Who among us stars, who writes, who directs? Assign jobs to everyone here.",
  "Have you ever cheated on anyone? What were the circumstances?",
  "Eating ass. Have you done it, or had it done to you? Tell us everything.",
  "Do you need an emotional connection to have great sex? If you’ve had a spectacular hookup that was purely physical, tell us everything.",
  "Assuming we were both single, would you hook up with me? How desperate would you have to be?",
  "Tell us about a time in which a romantic partner just didn’t understand how to do a certain sex thing.",
  "What’s the best compliment you’ve ever gotten on your sexual performance?",
  "How many people have you hooked up with off dating apps?",
  "If a studio were to make porn specifically for you, tailored to your specific tastes, what would it be like?",
  "What’s a sex thing you’ve never been able to try, but wish you could?",
  "Have you ever paid for porn? If not, how much do you owe the porn industry?",
  "Describe the present state of your pubic hair.",
  "If I cheat on my partner, is it absolutely essential that I tell them? Why or why not?",
  "Would you be (or have you been) a 'guest star' in another couple’s bedroom?",
  "What scared you the most about sex as you were coming of age?",
  "Do you have recurring fantasies that surprise you? Would they surprise us? Try us.",
  "What is your favorite sexual position and why?",
  "What’s the biggest mess you’ve created during sex? Did you have to clean it up, or did you leave it for someone else?",
  "Have you ever sent nudes? How do you compose, frame, and light these images?",
  "How open are you about your most intimate fantasies with your partner(s)?",
  "Do you think you're better suited to open relationships or monogamy? Have you tried each?",
  "Have you ever paid for sex work? Would you?",
  "Which of your hookups created the most drama? Was there permanent fallout?",
  "Have you ever had a threesome? If you haven’t yet, build your ideal trio.",
  "Who was the last person (besides your partner or your kids) whose junk you’ve seen?",
  "Have you ever worn someone else’s underwear, accidentally or on purpose? What was the circumstance?",
  "Are you loud during sex? Demonstrate with a dramatic interpretation of your signature sex sounds.",
  "Have you ever cried after-or during-sex? Were they tears of joy, love, or utter disappointment?",
  "What’s the last object you put inside yourself or another person?",
  "Have you ever been caught masturbating or having sex?",
  "Have I gotten sexier since you’ve known me?",
  "What sex-related word are you not sure how to pronounce?",
  "Have you ever filmed yourself having sex? What did you do with the footage?",
  "How would your partner (or your most recent ex) describe your sex life with a movie title?",
  "What’s something you wish your ex would have done sexually, but didn’t?",
  "What would it take for you to sleep with someone you’re not at all physically attracted to?",
  "How confident are you in your oral sex skills? What feedback have you gotten?",
  "Looking for a weird but true story about an inappropriate boner.",
  "Describe your sex life with a movie title, and tell us your reasoning.",
  "Describe your sex life with a song title.",
  "What’s the most creative you’ve ever had to get in order to smash? What was standing in your way, and how did you solve it?",
  "Imagine we’re your future (or current) children. Tell us how babies are made.",
  "Who here do you think you'd be most sexually compatible with? Present and past partners excluded. Remember, this is just hypothetical.",
  "What did you observe from porn that you later realized was unrealistic? How’d you make this discovery?",
  "Do you have a go-to sex move? Where did you learn it?",
  "Who was the last person (besides your partner or your doctor) who’s seen your junk?",
  "If you had to write a quick-start guide to getting you off, what are the key bullet points?",
  "What’s the kinkiest thing you’ve asked someone else to do? Did they oblige?",
  "If we were stuck on a desert island, how many days until we fuck out of boredom?",
  "Have you ever been injured during sex? Or injured someone else? Heartbreaks don’t count.",
  "Quick! Name your favorite porn star. And tell us about all the wonderful qualities that make them special.",
  "If I had a hot sibling, would they be off-limits, sex-wise?",
  "If I had a hot parent, would you let them seduce you?",
  "What will be the sexy nickname they give you when you live at the old-folks' home?",
  "Describe your first time having sex. Include every cringey detail.",
  "When was the last time you were tested for a sexually transmitted infection? What were the results?",
  "On the spectrum of 'sober as a judge' to 'falling-down drunk,' where do you have the best sex?",
  "Do you have an age ceiling for a one-night stand?",
  "Who here would have the best sexual chemistry with me? Based upon what evidence?"
],
};

export default questions;
